import React, { useRef, useState } from 'react'
import styles from './search-field.module.scss'

interface IProps {
  handleInputChange: any,
  modifiers?: string
  label: string
  disabled?: boolean
  name: string
  placeholder?: string
}

const SearchField = React.memo(function SearchField({ handleInputChange, modifiers, label, name, placeholder, disabled }: IProps) {
  const [inputValue, setInputValue] = useState('')
  const [focused, setFocused] = useState(false)
  const inputRef = useRef(null)

  const handleChange = (value: string) => {
    setInputValue(value)
    handleInputChange(value)
  }

  const handleBlur = () => {
    setFocused(false)
  }

  const handleFocus = () => {
    setFocused(true)
  }

  return (
    <div className={`${styles.inputField} ${modifiers ? modifiers : ''}`}>
      <label htmlFor={name} className={styles.inputLabel}>{label}</label>
      <div className={`${styles.inputWrapper} ${focused ? styles.active : ''}`}>
        <input
          ref={inputRef}
          id={name}
          className={styles.input}
          placeholder={placeholder}
          type='text'
          disabled={disabled}
          value={focused || inputValue ? inputValue : label}
          autoComplete='off'
          onChange={(e) => handleChange(e.target.value)}
          onFocus={handleFocus}
          onBlur={handleBlur}
        />
      </div>
    </div>
  )
})

export default SearchField
